import { getStore, removeStore, setStore } from "@/util/store";
import { metmaterialMetCombFindattrlist } from "@/api/hb-record-manage/goods-details";

const goodSpecStores = {
  state: {
    // 当前操作的商品id
    goodSpecCurrentEditId: "",
    // 当前操作的商品名称
    goodSpecCurrentEditName: "",
    // 当前id下套餐所有的固定规格
    goodSpecCurrentSpecFixed: [],
    // 当前id下套餐所有的可选规格
    goodSpecCurrentSpecUnFixed: [],
    // tableLoading - 固定规格
    fixedTableLoading:false,
    // tableLoading - 可选规格
    unFixedTableLoading:false,
  },
  actions: {
    // 设置store中的商品data
    setGoodSpecCurrentEditData({ commit }, data) {
      const { id, name } = data
      commit("SET_GOODSPECCURRENTEDITID", id);
      commit("SET_GOODSPECCURRENTEDITNAME", name);
    },
    setGoodSpecCurrentEditId({ commit }, id) {
      commit("SET_GOODSPECCURRENTEDITID", id);
    },
    // 获取当前 页面的固定规格
    setGoodSpecCurrentSpecFixed({ commit,state }, data) {
      state.fixedTableLoading = true
      return new Promise((resolve, reject) => {
        metmaterialMetCombFindattrlist(state.goodSpecCurrentEditId, 1)
          .then((response) => {
            let { data } = response.data;
            console.log(data, "---固定规格");
            commit("SET_GOODSPECCURRENTSPECFIXED", data);
            state.fixedTableLoading = false
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取当前 页面的可选规格
    setGoodSpecCurrentSpecUnFixed({ commit, state }, data) {
      state.unFixedTableLoading = true
      return new Promise((resolve, reject) => {
        metmaterialMetCombFindattrlist(state.goodSpecCurrentEditId, 0)
          .then((response) => {
            // --- 赋值没拿到的话要看看这里
            let { data } = response.data;     
            commit("SET_GOODSPECCURRENTSPECUNFIXED", data);
            state.unFixedTableLoading = false
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 同时获取 固定规格和可选规格
    getCurrentSpecAllDataList({dispatch,commit}){
      console.log('---调用了');
      const p1 =  dispatch('setGoodSpecCurrentSpecFixed')
      const p2 =  dispatch('setGoodSpecCurrentSpecUnFixed')
      Promise.all([p1, p2]).then((values) => {  
        console.log(values); // 输出: ‌:ml-citation{ref="4,5" data="citationList"}
        const arr = values.map(ele => ele).flat(Infinity)
        console.log(arr);
        // commit("SET_COUNTGOODSFIXEDANDUNFIXED", arr.length);
      }).catch((reason) => {
        console.error(reason); // 如果任何一个promise失败，将执行这里
      });
    },
    clearCurrentSpecAllDataList({dispatch,commit,state}){
      console.log('---调用了');
      state.unFixedTableLoading = false
      state.fixedTableLoading = false
      commit("SET_GOODSPECCURRENTSPECFIXED", []);
      commit("SET_GOODSPECCURRENTSPECUNFIXED", []);
    },
  },
  mutations: {
    // 设置id
    SET_GOODSPECCURRENTEDITID: (state, goodSpecCurrentEditId) => {
      state.goodSpecCurrentEditId = goodSpecCurrentEditId;
    },
    SET_GOODSPECCURRENTEDITNAME:(state, goodSpecCurrentEditName)=>{
      state.goodSpecCurrentEditName = goodSpecCurrentEditName
    },
    SET_GOODSPECCURRENTSPECFIXED: (state, goodSpecCurrentSpecFixed) => {
      state.goodSpecCurrentSpecFixed = goodSpecCurrentSpecFixed;
    },
    SET_GOODSPECCURRENTSPECUNFIXED: (state, goodSpecCurrentSpecUnFixed) => {
      state.goodSpecCurrentSpecUnFixed = goodSpecCurrentSpecUnFixed;
    },

  },
};
export default goodSpecStores;
